<template>
  <div class="complaint-progress-page">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="$t('progress.title')"
      left-arrow
      @click-left="$router.back()"
    />

    <div class="container">
      <!-- 查询输入区域 -->
      <div class="search-section">
        <div class="input-group">
          <van-field
            v-model="complaintId"
            :placeholder="$t('progress.enterComplaintId')"
            clearable
            maxlength="20"
            :error-message="errorMessage"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                :loading="searchLoading"
                @click="handleSearch"
              >
                {{ $t('progress.search') }}
              </van-button>
            </template>
          </van-field>
        </div>

        <!--        扫码查询-->
        <!--        <div class="scan-section">-->
        <!--          <van-button-->
        <!--            block-->
        <!--            type="default"-->
        <!--            icon="scan"-->
        <!--            @click="showScanDialog = true"-->
        <!--          >-->
        <!--            {{ $t('progress.scanQrCode') }}-->
        <!--          </van-button>-->
        <!--        </div>-->
      </div>

      <!-- 查询结果 -->
      <div
        v-if="complaintData"
        class="result-section"
      >
        <!-- 基本信息卡片 -->
        <van-cell-group class="info-card">
          <van-cell
            :title-style="{'text-align': 'left'}"
            :title="$t('progress.complaintId')"
            :value="complaintData.code"
          />
          <van-cell
            :title-style="{'text-align': 'left'}"
            :title="$t('progress.submitTime')"
            :value="formatDate(complaintData.createdTime)"
          />
          <van-cell
            :title-style="{'text-align': 'left'}"
            :title="$t('progress.productName')"
            :value="complaintData.productName"
          />
          <!--          <van-cell-->
          <!--            :title="$t('progress.complaintType')"-->
          <!--            :value="complaintData.type"-->
          <!--          />-->
          <van-cell
            :title-style="{'text-align': 'left'}"
            :title="$t('progress.description')"
            :value="complaintData.problemDescription"
          />
        </van-cell-group>

        <!-- 进度时间轴 -->
        <div class="progress-card">
          <div class="card-header">
            <van-icon name="clock" />
            <span>{{ $t('progress.progressTitle') }}</span>
            <van-tag
              :type="getStatusType(complaintData.processingStatus)"
              class="status-tag"
            >
              {{ getStatusText(complaintData.processingStatus) }}
            </van-tag>
          </div>

          <van-steps
            direction="vertical"
            :active="complaintData.currentStep"
            active-color="#1989fa"
          >
            <van-step
              v-for="step in complaintData.processLogs"
              :key="step.id"
              :status="getStepStatus(step.step, complaintData.currentStep)"
            >
              <div class="step-content">
                <div class="step-title">
                  {{ step.actionDescription }}
                </div>
                <div class="step-time">
                  {{ formatDate(step.createdTime) }}
                </div>
                <div
                  v-if="step.operatorName"
                  class="step-operator"
                >
                  {{ $t('progress.operator') }}: {{ step.operatorName }}
                </div>
                <div
                  v-if="step.remark"
                  class="step-remarks"
                >
                  {{ step.remark }}
                </div>
              </div>
            </van-step>
          </van-steps>
        </div>

        <!-- 处理结果（如果已完成） -->
        <div
          v-if="complaintData.status === 'completed'"
          class="result-card"
        >
          <div class="card-header">
            <van-icon name="certificate" />
            <span>{{ $t('progress.resultTitle') }}</span>
          </div>
          <div class="result-content">
            <p><strong>{{ $t('progress.result') }}:</strong> {{ complaintData.result }}</p>
            <p v-if="complaintData.solution">
              <strong>{{ $t('progress.solution') }}:</strong> {{ complaintData.solution }}
            </p>
            <p v-if="complaintData.followUp">
              <strong>{{ $t('progress.followUp') }}:</strong> {{ complaintData.followUp }}
            </p>
          </div>
        </div>

        <!-- 联系客服 -->
        <!--        <div class="contact-card">-->
        <!--          <div class="contact-content">-->
        <!--            <van-icon-->
        <!--              name="service"-->
        <!--              class="contact-icon"-->
        <!--            />-->
        <!--            <div class="contact-info">-->
        <!--              <h4>{{ $t('progress.needHelp') }}</h4>-->
        <!--              <p>{{ $t('progress.contactCustomerService') }}</p>-->
        <!--            </div>-->
        <!--            <van-button-->
        <!--              size="small"-->
        <!--              type="primary"-->
        <!--              @click="contactCustomerService"-->
        <!--            >-->
        <!--              {{ $t('progress.contactNow') }}-->
        <!--            </van-button>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <!-- 空状态 -->
      <div
        v-else-if="hasSearched && !complaintData"
        class="empty-state"
      >
        <van-empty
          :description="$t('progress.noData')"
          image="search"
        >
          <van-button
            round
            type="primary"
            @click="complaintId = ''; hasSearched = false"
          >
            {{ $t('progress.searchAgain') }}
          </van-button>
        </van-empty>
      </div>

      <!-- 使用说明 -->
      <div
        v-else
        class="instruction-section"
      >
        <div class="instruction-card">
          <h3>{{ $t('progress.howToUse') }}</h3>
          <ul>
            <li>{{ $t('progress.instruction1') }}</li>
            <!--            <li>{{ $t('progress.instruction2') }}</li>-->
            <li>{{ $t('progress.instruction3') }}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 扫码弹窗 -->
    <!--    <van-popup-->
    <!--      v-model:show="showScanDialog"-->
    <!--      round-->
    <!--      position="bottom"-->
    <!--      :style="{ height: '60%' }"-->
    <!--    >-->
    <!--      <div class="scan-dialog">-->
    <!--        <div class="dialog-header">-->
    <!--          <h3>{{ $t('progress.scanQrCode') }}</h3>-->
    <!--          <van-icon-->
    <!--            name="cross"-->
    <!--            @click="showScanDialog = false"-->
    <!--          />-->
    <!--        </div>-->

    <!--        <div class="scan-content">-->
    <!--          &lt;!&ndash; 这里可以集成实际的扫码组件 &ndash;&gt;-->
    <!--          <div class="scan-placeholder">-->
    <!--            <van-icon-->
    <!--              name="scan"-->
    <!--              size="60"-->
    <!--            />-->
    <!--            <p>{{ $t('progress.scanPlaceholder') }}</p>-->
    <!--            <van-button-->
    <!--              type="primary"-->
    <!--              @click="mockScanResult"-->
    <!--            >-->
    <!--              {{ $t('progress.mockScan') }}-->
    <!--            </van-button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </van-popup>-->
  </div>
</template>

<script lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast, showConfirmDialog } from 'vant'
import { queryReportDetail } from '@/api/report'
import moment from 'moment'
export default {
  setup () {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()

    // 响应式数据
    const reportCode = ref('')
    const errorMessage = ref('')
    const searchLoading = ref(false)
    const hasSearched = ref(false)
    const showScanDialog = ref(false)
    const complaintData = ref<any>(null)

    // 模拟投诉数据
    const mockComplaintData = {
      id: 'CP202312150001',
      submitTime: new Date('2023-12-15 14:30:00'),
      productName: '高端白酒礼盒装',
      type: '产品质量问题',
      description: '购买的产品包装破损，怀疑为假冒产品',
      status: 'in_progress', // pending, in_progress, completed
      currentStep: 2,
      steps: [
        {
          step: 1,
          title: '投诉已提交',
          time: new Date('2023-12-15 14:30:00'),
          operator: '系统',
          remarks: '您的投诉已成功提交，我们将尽快处理'
        },
        {
          step: 2,
          title: '投诉审核中',
          time: new Date('2023-12-15 16:45:00'),
          operator: '审核专员-张明',
          remarks: '正在核实您提交的产品信息和相关证据'
        },
        {
          step: 3,
          title: '问题调查中',
          time: new Date('2023-12-16 09:15:00'),
          operator: '调查员-李华',
          remarks: '已联系品牌方进行产品真伪鉴定'
        },
        {
          step: 4,
          title: '处理完成',
          time: null,
          operator: null,
          remarks: null
        }
      ],
      result: '确认为正品，包装问题为运输过程中造成',
      solution: '品牌方已同意更换全新产品',
      followUp: '新商品将于3个工作日内寄出，请注意查收'
    }

    // 计算属性
    const isValidComplaintId = computed(() => {
      return reportCode.value.length >= 8 && /^[A-Za-z0-9]+$/.test(reportCode.value)
    })

    // 方法
    const handleSearch = async () => {
      if (!isValidComplaintId.value) {
        errorMessage.value = t('progress.invalidId')
        return
      }

      errorMessage.value = ''
      searchLoading.value = true

      queryReportDetail(reportCode.value).then(res => {
        searchLoading.value = false
        complaintData.value = res
        hasSearched.value = true
        complaintData.value.processLogs.forEach((log: any, index: number) => {
          log.stepId = index
        })
        complaintData.value.currentStep = complaintData.value.processLogs.length - 1
      }).catch(error => {
        searchLoading.value = false
        showToast(`${t('progress.searchFailed')} ${error.msg}`)
      })
    }

    const formatDate = (date: string | null) => {
      if (!date) return '-'
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }

    const getStatusType = (status: number) => {
      const types: any = {
        0: 'warning',
        1: 'primary',
        2: 'success',
        3: 'danger'
      }
      return types[status] || ''
    }

    const getStatusText = (status: string) => {
      const texts: any = {
        0: t('progress.statusPending'),
        1: t('progress.statusInProgress'),
        2: t('progress.statusCompleted'),
        3: t('progress.statusClosed')
      }
      return texts[status] || status
    }

    const getStepStatus = (step: number, currentStep: number) => {
      if (step < currentStep) return 'finish'
      if (step === currentStep) return 'process'
      return 'waiting'
    }

    const contactCustomerService = () => {
      showConfirmDialog({
        title: t('progress.contactService'),
        message: t('progress.contactConfirm')
      }).then(() => {
        // 这里可以跳转到客服页面或拨打电话
        showToast(t('progress.contactingService'))
      })
    }

    const mockScanResult = () => {
      reportCode.value = 'CP202312150001'
      showScanDialog.value = false
      // 延迟执行搜索，确保弹窗关闭后再执行
      setTimeout(() => {
        handleSearch()
      }, 300)
    }

    // 初始化：检查URL参数
    const initFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search)
      const idFromUrl = urlParams.get('id')
      if (idFromUrl) {
        reportCode.value = idFromUrl
        handleSearch()
      }
    }

    // 初始化
    initFromUrl()

    onMounted(() => {
      reportCode.value = route.query.code as string || ''
      if (reportCode.value && reportCode.value !== '') {
        handleSearch()
      }
    })
    return {
      complaintId: reportCode,
      errorMessage,
      searchLoading,
      hasSearched,
      showScanDialog,
      complaintData,
      formatDate,
      getStatusType,
      getStatusText,
      getStepStatus,
      contactCustomerService,
      mockScanResult,
      handleSearch
    }
  }
}

</script>

<style lang="scss" scoped>
.complaint-progress-page {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.container {
  padding: 16px;
}

.search-section {
  margin-bottom: 20px;

  .input-group {
    margin-bottom: 16px;
  }

  .scan-section {
    .van-button {
      height: 44px;
    }
  }
}

.result-section {
  .info-card,
  .progress-card,
  .result-card,
  .contact-card {
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
  }
}

.card-header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: white;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 1px solid #f0f0f0;

  .van-icon {
    margin-right: 8px;
    color: #1989fa;
  }

  .status-tag {
    margin-left: auto;
  }
}

.progress-card {
  background: white;

  :deep(.van-steps) {
    padding: 16px;
  }

  .step-content {
    padding-left: 8px;

    .step-title {
      font-weight: 500;
      margin-bottom: 4px;
    }

    .step-time {
      font-size: 12px;
      color: #969799;
      margin-bottom: 4px;
    }

    .step-operator {
      font-size: 12px;
      color: #646566;
      margin-bottom: 4px;
    }

    .step-remarks {
      font-size: 13px;
      color: #323233;
      background: #f7f8fa;
      padding: 8px;
      border-radius: 4px;
      margin-top: 4px;
    }
  }
}

.result-card {
  background: white;

  .result-content {
    padding: 16px;

    p {
      margin-bottom: 12px;
      line-height: 1.5;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      color: #323233;
    }
  }
}

.contact-card {
  background: white;

  .contact-content {
    display: flex;
    align-items: center;
    padding: 16px;

    .contact-icon {
      font-size: 24px;
      color: #1989fa;
      margin-right: 12px;
    }

    .contact-info {
      flex: 1;

      h4 {
        margin: 0 0 4px;
        font-size: 14px;
        font-weight: 600;
      }

      p {
        margin: 0;
        font-size: 12px;
        color: #969799;
      }
    }
  }
}

.instruction-section {
  .instruction-card {
    background: white;
    padding: 16px;
    border-radius: 8px;

    h3 {
      margin: 0 0 12px;
      font-size: 16px;
      font-weight: 600;
    }

    ul {
      margin: 0;
      padding-left: 20px;

      li {
        margin-bottom: 8px;
        line-height: 1.5;
        color: #646566;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.empty-state {
  margin-top: 60px;
}

.scan-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }

    .van-icon {
      font-size: 18px;
      color: #969799;
    }
  }

  .scan-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    .scan-placeholder {
      text-align: center;

      .van-icon {
        color: #dcdee0;
        margin-bottom: 16px;
      }

      p {
        margin: 0 0 20px;
        color: #969799;
      }
    }
  }
}

// 响应式设计
@media (max-width: 480px) {
  .container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
    font-size: 15px;
  }

  .progress-card :deep(.van-steps) {
    padding: 12px;
  }
}
</style>
